module.exports = __webpack_public_path__ + "img/6.e10867f8.jpg";